import React, {FC, useCallback, useEffect, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {useLoadedData} from '../../../../hooks/useGetLoadedData'
import {CommissionListParams} from '../../../../../services/cellcast.v2.types'
import {
  useLazyAdminGetUserCommissionsQuery,
  useLazyGetCommissionsQuery,
} from '../../../../../services/cellcast.v2'
import {useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../../Components/NodataYet'
import {KTSVG} from '../../../../../_metronic/helpers'
import Select from 'react-select'
import moment from 'moment-timezone'
import { useLocation } from 'react-router-dom'

type ReferralCommissionsProps = {}
const CommissionTypeOptions = [
  {value: '', label: 'Select Type'},
  {value: 'credit', label: 'Credit'},
  {value: 'money', label: 'Money'},
]

const CampTypeOptions = [
  {value: '', label: 'Select Type'},
  {value: 'sms', label: 'sms'},
  {value: 'mms', label: 'mms'},
]

export const ReferralCommissions: FC<ReferralCommissionsProps> = (req, res) => {
  const {calculate, loadedData, setLoadedData} = useLoadedData()
  
  const location = useLocation()
  const {userProp} = location.state || ({} as any)
  
  const userDataState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user || {})
  const userData = userProp?.user ? userProp.user : userDataState

  const [params, setParams] = useState<CommissionListParams>({
    page: 1,
    limit: 10,
  })

  const [triggerFetch, setTriggerFetch] = useState(false)

  const [fetch, {isLoading, data, isFetching}] = useLazyAdminGetUserCommissionsQuery()

  useEffect(() => {
    if (userData._id) {
      fetch({...params, userId: userData._id})
    }
  }, [userData])

  useEffect(() => {
    if (triggerFetch && triggerFetch === true) {
      doFetch({...params, userId: userData._id})
    }
    setTriggerFetch(false)
  }, [triggerFetch])

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  const doFetch = useCallback(
    (params) => {
      fetch(params)
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error Fetch Message:', res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [fetch]
  )

  return (
    <div className='mt-8'>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-5'>
          <h3 className='card-title align-items-start  flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>Commissions</span>
            <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
          </h3>
          <div className='card-toolbar'>
            <button
              className={`position-relative btn btn-light-primary filter_btn `}
              data-kt-menu-trigger='hover'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
              Filter
            </button>

            <div
              className={`position-absolute menu menu-sub menu-sub-dropdown w-250px w-md-300px `}
              data-kt-menu='true'
            >
              <div className='px-7 py-5'>
                <div className='mb-10'>
                  <label className='form-label fw-bold'>Commission Type:</label>
                  <Select
                    placeholder='Select Type'
                    value={
                      CommissionTypeOptions.find((el) => el.value === params?.commissionType) ||
                      CommissionTypeOptions[0]
                    }
                    options={CommissionTypeOptions}
                    onChange={(e: any) => {
                      setParams({...params, commissionType: e.value})
                      setTriggerFetch(true)
                    }}
                  />
                </div>

                <div className='mb-10'>
                  <label className='form-label fw-bold'>Camp Type:</label>
                  <Select
                    placeholder='Select Type'
                    value={
                      CampTypeOptions.find((el) => el.value === params?.campType) ||
                      CampTypeOptions[0]
                    }
                    options={CampTypeOptions}
                    onChange={(e: any) => {
                      setParams({...params, campType: e.value})
                      setTriggerFetch(true)
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data.items && data.data.items.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='min-w-140px'>Created At</th>
                        <th className='min-w-150px'>Affiliate User</th>
                        <th className='min-w-140px'>Camp Type</th>
                        <th className='min-w-140px'>Commission Type</th>
                        <th className='min-w-140px'>Topup Amount</th>
                        <th className='min-w-140px'>Rate</th>
                        <th className='min-w-100px'>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={5} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((item, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-dashed border-2 border-bottom'>
                                <td className='top-align'>
                                  <span className='text-dark-400  p-0'>
                                    {moment(item.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                                  </span>
                                </td>
                                <td className='top-align'>{item?.affiliateUserData?.name || '--'}</td>
                                <td className='top-align'>{item.camp_type || '--'}</td>
                                <td className='top-align'>{item.type || '--'}</td>
                                <td className='top-align'>
                                  {item.top_up_amount ? `$${item.top_up_amount}` : '--'}
                                </td>
                                <td className='top-align'>{item.rate ? `${item.rate}%` : '--'}</td>
                                <td className='top-align'>
                                  {item.amount ? item.amount.toFixed(2) : '--'}
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: e.target.value})
                      setTriggerFetch(true)
                    }}
                    value={params.limit || 10}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data.data.total ? data.data.total : 0
                      } Messages`}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={data?.data?.totalPages}
                    onPageChange={(e: any) => {
                      setParams({...params, page: e.selected + 1})
                      setTriggerFetch(true)
                    }}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet message='No commissions (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default ReferralCommissions
